import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import moment from 'moment';
import { environment } from 'src/environments/environment';

const FEATURE_PATH = '/feature/';
const API_FEATURE_URL = environment.basePath + FEATURE_PATH;
const CHECK_FEATURE_DELAY = 15;
const CHECK_FEATURE_UNIT = 'minutes';

export enum FeatureKey {
  JFSE = 'JFSE',
  E_PRESCRIPTION = 'E_PRESCRIPTION',
  STELLAIR = 'STELLAIR',
  BCB = 'BCB',
  RECHERCHE_MULTI_CRITERES_FICHE_PATIENT = 'RECHERCHE_MULTI_CRITERES_FICHE_PATIENT',
  FUSION_DOSSIERS_PATIENT = 'FUSION_DOSSIERS_PATIENT',
  RECHERCHE_ANOMALIE_IDENTITES = 'RECHERCHE_ANOMALIE_IDENTITES',
  EXPORT_PATIENT = 'EXPORT_PATIENT',
  FORMULAIRES = 'FORMULAIRES',
  APPELS_AUTO_INSI = 'APPELS_AUTO_INSI',
  DMP_SEGUR_DICA = 'DMP_SEGUR_DICA',
  USE_EDC_REST_PROXY = 'USE_EDC_REST_PROXY',
}

export interface Feature {
  key: string;
  description?: string;
  label: string;
  type: FeatureType;
  value: boolean;
}

export enum FeatureType {
  GLOBAL = "global",
  CABINET = "cabinet",
  PROFIL = "profil",
}

@Injectable({
  providedIn: 'root'
})
export class FeatureService {

  private _featureMap = new Map<FeatureKey, boolean>();
  private _lastCheck: moment.Moment | undefined = undefined;

  constructor(
    private http: HttpClient,
  ) { }

  public async canUseFeature(featureKey: FeatureKey): Promise<boolean> {
    let feature = false;
    if (this._featureMap.has(featureKey) && this._lastCheck && moment().diff(this._lastCheck, CHECK_FEATURE_UNIT) < CHECK_FEATURE_DELAY) {
      feature = this._featureMap.get(featureKey);
    } else {
      feature = await this.http.get<boolean>(`${API_FEATURE_URL}isEnabled/${featureKey}`).toPromise();
      this.setCache(featureKey, feature);
    }
    return feature;
  }

  public setCache(featureKey: FeatureKey, value: boolean): void {
    this._featureMap.set(featureKey, value);
    this._lastCheck = moment();
  }

  public clearCache(): void {
    this._featureMap.clear();
    this._lastCheck = undefined;
  }

  public async getAllFeatures(featureType: FeatureType | 'ALL', targetId?: string): Promise<Array<Feature>> {
    try {
      let params: HttpParams = new HttpParams();
      if (targetId) {
        params = params.set('id', targetId);
      }
      return await this.http.get<Array<Feature>>(`${API_FEATURE_URL}all/${featureType}`, {
        params: params,
      }).toPromise();
    } catch (e) {
      console.error(e);
      throw e;
    }
  }

  public async updateFeatures(features: Array<Feature>, featureType: FeatureType, targetId?: string): Promise<void> {
    try {
      let params: HttpParams = new HttpParams();
      if (targetId) {
        params = params.set('id', targetId);
      }
      await this.http.put(`${API_FEATURE_URL}all/${featureType}`, features, {
        params: params,
      }).toPromise();
    } catch (e) {
      console.error(e);
      throw e;
    }
  }
}
